/** @deprecated - this is moved to libs */
export enum AppRoutesEnum {
    /* Login */
    Login = 'inloggen',
    Logout = 'uitloggen',
    HemaActivation = 'activeren',
    /* My Zone */
    My = 'mijn',
    MyZoneOld = 'mijn-verzekeringsmap',
    MyZone = 'verzekeringsmap',
    MyInsurances = 'mijn-verzekeringen',
    MyInvoices = 'mijn-facturen',
    MyData = 'mijn-gegevens',
    MyClaims = 'mijn-schades',
    MyClaimsClaim = 'schadeclaim',
    MyAnnualReward = 'jaarbalans',
    Payment = 'betalen',
    BankAccount = 'bankrekening',
    Verify = 'verifieren',
    Status = 'status',
    /* Funnel */
    Calculate = 'berekenen',
    Activate = 'activeren',
    Thanks = 'bedankpagina',
    /* Insurances */
    Insurances = 'verzekeringen',
    CancelInsurance = 'opzeggen',
    CarInsurance = 'autoverzekering',
    BicycleInsurance = 'fietsverzekering',
    MopedInsurance = 'brommerverzekering',
    ScooterInsurance = 'scooterverzekering',
    MotorInsurance = 'motorverzekering',
    TravelInsurance = 'reisverzekering',
    HomeInsurance = 'woonverzekering',
    InventoryInsurance = 'inboedelverzekering',
    BuildingInsurance = 'opstalverzekering',
    LegalInsurance = 'rechtsbijstandverzekering',
    CaravanInsurance = 'caravanverzekering',
    AccidentInsurance = 'ongevallenverzekering',
    LiabilityInsurance = 'aansprakelijkheidsverzekering',
    PetInsurance = 'dierenverzekering',
    DogInsurance = 'hondenverzekering',
    CatInsurance = 'kattenverzekering',
    /* Damage */
    Damage = 'schade',
    DamageRepair = 'schadeherstel',
    DamageReportingHowitWorks = 'hoe-werkt-online-schademelden',
    /* Other pages */
    AnnualReward = 'jaarbalans',
    OptOut = 'optout',
    AnnualReward2020 = 'jaarbeloning-2020',
    AnnualReward2021 = 'jaarbeloning-2021',
    AnnualReward2022 = 'jaarbeloning-2022',
    AnnualRewardMostRecent = 'jaarbalans-2024',
    Avg = 'avg',
    Collectivity = 'collectiviteit',
    Contact = 'contact',
    Reviews = 'reviews',
    Cookies = 'cookies',
    About = 'over-inshared',
    EverythingOnline = 'alles-online',
    PayPremium = 'premie-betalen',
    Vacancies = 'werken-bij',
    Privacy = 'privacy',
    CustomerSatisfaction = 'hoe-tevreden-zijn-klanten',
    SmartTips = 'slimme-tips',
    SwitchService = 'overstaphulp',
    Prevention = 'preventie',
    Terminate = 'opzeggen',
    OurBenefits = 'onze-benefits',
    // Claim funnel
    ClaimFunnel = 'verzekeringsmap/mijn-schades/schademelden',
    MyClaimsNew = 'verzekeringsmap/mijn-schades',
    OldClaimFunnel = '/mijn-verzekeringsmap/schaderegelen#/schademelden',
    OldClaimFunnelDossier = '/mijn-verzekeringsmap/schaderegelen#/schademap',
    PageNotFound = '404',
    // WINS-12158 Contact pages to Dato/ssg
    Complaint = 'klacht',
    Disclaimer = 'disclaimer',
    Question = 'vraag',
    ResponseTimes = 'reactietermijnen',
}
